import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import * as constants from "../constants"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeRequestFinancialDocPayed extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,

                  financialDoc: null,
                  orderBy: "request_financial_doc_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newFinancialDoc: true,

                  optionAgent: [{ value: "0", label: "همه نماینده های بیمه" }],
                  selectedAgent: { value: "0", label: "همه نماینده های بیمه" },

                  optionNumDoc: [{ value: "0", label: "همه سند ها" }],
                  selectedNumDoc: { value: "0", label: "همه سند ها" },
            }
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        financialDoc: row2,
                        newFinancialDoc: false,
                  },
                  () => {}
            )
      }

      newFinancialDoc = (event) => {
            this.setState({
                  financialDoc: null,
                  newFinancialDoc: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getFinancialDocPaing()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getFinancialDocPaing() {
            const { rowsPerPage, page } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {})

                              var State = [{ value: "0", label: "همه سند ها" }]
                              var State2 = [{ value: "0", label: "همه نمایندگان" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].request_financial_doc_id, label: arr.data[k].request_financial_doc_num })
                                    State2.push({
                                          value: arr.data[k].agent_id,
                                          label: arr.data[k].agent_name + " " + arr.data[k].agent_family + "-" + arr.data[k].agent_mobile,
                                    })
                              }
                              self.setState({ optionNumDoc: State, selectedNumDoc: State[0] })
                              self.setState({ optionAgent: State2, selectedAgent: State2[0] })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_doc")
            fd.append("mode", "doc_payed")
            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/financialpaying`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      handleAgent = (selectedAgent) => {
            this.setState({ selectedAgent: selectedAgent }, () => {
                  this.filterList()
            })
      }

      handleNumDoc = (selectedNumDoc) => {
            this.setState({ selectedNumDoc: selectedNumDoc }, () => {
                  this.filterList()
            })
      }

      filterList = () => {
            const { requestinfos, selectedAgent, selectedNumDoc } = this.state
            var i, temparray, temparray2
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (temparray[i].agent_id === selectedAgent.value || selectedAgent.value === "0") &&
                        (temparray[i].request_financial_doc_id === selectedNumDoc.value || selectedNumDoc.value === "0")
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ requestinfofilter: temparray2 }, () => {})
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getFinancialDocPaing()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getFinancialDocPaing()
            })
      }

      render() {
            const { classes } = this.props
            const {
                  optionAgent,
                  selectedAgent,
                  optionNumDoc,
                  selectedNumDoc,
                  financialDoc,
                  snackMode,
                  snackstr,
                  showSnack,
                  newFinancialDoc,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شماره سند</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شماره سند"}
                                                                              value={selectedNumDoc}
                                                                              onChange={this.handleNumDoc}
                                                                              options={optionNumDoc}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نماینده</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نماینده"}
                                                                              value={selectedAgent}
                                                                              onChange={this.handleAgent}
                                                                              options={optionAgent}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          {newFinancialDoc || financialDoc === null ? null : (
                                                <Container component="main" maxWidth="lg">
                                                      <Paper elevation={4} className={classes.root}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Typography variant="h6">{"سند مالی در حال پرداخت"}</Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شماره سند:  " + financialDoc["request_financial_doc_num"]}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"مبلغ کل سند:  "}
                                                                              <NumberFormat
                                                                                    displayType={"text"}
                                                                                    value={financialDoc["request_financial_doc_price"]}
                                                                                    thousandSeparator={true}
                                                                                    prefix={" ریال"}
                                                                              />
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={2}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"تعداد درخواست های پرداختی:  " +
                                                                                    financialDoc["request_financial_doc_numdoc"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام نماینده:  " +
                                                                                    financialDoc["agent_name"] +
                                                                                    " " +
                                                                                    financialDoc["agent_family"] +
                                                                                    " -همراه:" +
                                                                                    financialDoc["agent_mobile"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام بانک:  " + financialDoc["agent_bankname"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شماره حساب:  " + financialDoc["agent_banknum"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شماره شبا:  " + financialDoc["agent_banksheba"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام کارمند :" +
                                                                                    financialDoc["employee_name"] +
                                                                                    " " +
                                                                                    financialDoc["employee_family"]}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ صدور سند: "}
                                                                              {new JDate(
                                                                                    new Date(
                                                                                          parseInt(
                                                                                                Moment(
                                                                                                      financialDoc["request_financial_doc_date"],
                                                                                                      "YYYY-M-D HH:mm:ss"
                                                                                                ).format("x")
                                                                                          )
                                                                                    )
                                                                              ).format("YYYY/MM/DD") +
                                                                                    " " +
                                                                                    Moment(
                                                                                          financialDoc["request_financial_doc_date"],
                                                                                          "YYYY-M-D HH:mm:ss"
                                                                                    ).format("HH:mm:ss")}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پرداخت: "}
                                                                              {new JDate(
                                                                                    new Date(
                                                                                          parseInt(
                                                                                                Moment(
                                                                                                      financialDoc["request_financial_doc_peydate"],
                                                                                                      "YYYY-M-D HH:mm:ss"
                                                                                                ).format("x")
                                                                                          )
                                                                                    )
                                                                              ).format("YYYY/MM/DD")}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <Typography variant="h7">
                                                                              {"کد رهگیری پرداخت: "}
                                                                              {"نام کارمند :" + financialDoc["request_financial_doc_code"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        {"نام کارمند :" +
                                                                              financialDoc["pey_employee_name"] +
                                                                              " " +
                                                                              financialDoc["pey_employee_family"]}
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newFinancialDoc}
                                                                              >
                                                                                    {"بستن"}
                                                                              </Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Paper>
                                                </Container>
                                          )}
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"request_financial_doc_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "request_financial_doc_id" ? order : false
                                                                                    }
                                                                              >
                                                                                    {"آیدی سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_financial_doc_id"}
                                                                                          direction={
                                                                                                orderBy === "request_financial_doc_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_financial_doc_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_financial_doc_num"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شماره سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_financial_doc_num"}
                                                                                          direction={
                                                                                                orderBy === "request_financial_doc_num"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_financial_doc_num")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_financial_doc_price"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_financial_doc_price"}
                                                                                          direction={
                                                                                                orderBy === "request_financial_doc_price"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_financial_doc_price")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_financial_doc_date"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ صدور سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_financial_doc_date"}
                                                                                          direction={
                                                                                                orderBy === "request_financial_doc_date"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_financial_doc_date")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"request_financial_doc_numdoc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تعداد درخواست های سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_financial_doc_numdoc"}
                                                                                          direction={
                                                                                                orderBy === "request_financial_doc_numdoc"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_financial_doc_numdoc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"agent_id"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام نماینده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_id"}
                                                                                          direction={orderBy === "agent_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_financial_doc_employee_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"کارمند صادر کننده سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_financial_doc_employee_id"}
                                                                                          direction={
                                                                                                orderBy === "request_financial_doc_employee_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "request_financial_doc_employee_id"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                              return (
                                                                                    <TableRow
                                                                                          hover
                                                                                          role="checkbox"
                                                                                          tabIndex={-1}
                                                                                          key={row["request_financial_doc_id"]}
                                                                                          value={row}
                                                                                          onClick={() => {
                                                                                                this.handleSelectRows(row)
                                                                                          }}
                                                                                    >
                                                                                          <TableCell
                                                                                                key={"request_financial_doc_id"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                {row["request_financial_doc_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                                key={"request_financial_doc_num"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                {row["request_financial_doc_num"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                                key={"request_financial_doc_price"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["request_financial_doc_price"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                                key={"request_financial_doc_price"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        row[
                                                                                                                              "request_financial_doc_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      " " +
                                                                                                      Moment(
                                                                                                            row["request_financial_doc_date"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                                key={"request_financial_doc_numdoc"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                {row["request_financial_doc_numdoc"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"agent_id"} align={"center"}>
                                                                                                {row["agent_name"] + " " + row["agent_family"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"employee_name"} align={"center"}>
                                                                                                {row["employee_name"] + " " + row["employee_family"]}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                              )
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeRequestFinancialDocPayed)
